module.exports = require('./head');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/fp/first.js
// module id = 686
// module chunks = 7